import { render, staticRenderFns } from "./OrderBox.vue?vue&type=template&id=3f69e588&scoped=true&"
import script from "./OrderBox.vue?vue&type=script&lang=js&"
export * from "./OrderBox.vue?vue&type=script&lang=js&"
import style0 from "./OrderBox.vue?vue&type=style&index=0&id=3f69e588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69e588",
  null
  
)

export default component.exports